import { render, staticRenderFns } from "./theme.header.vue?vue&type=template&id=1a639008&"
import script from "./theme.header.vue?vue&type=script&lang=js&"
export * from "./theme.header.vue?vue&type=script&lang=js&"
import style0 from "./theme.header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports